import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { AdvAnnouncement } from "../../../../../../common/services/api/resources/announcement/adv-announcement";
import { Recording } from "../../../../../../common/services/api/resources/recording/recording";
@Component({
  selector: "onsip-adv-announcements-recording-tab",
  templateUrl: "./adv-announcements-recording-tab.component.html",
  styleUrls: ["./adv-announcements-recording-tab.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdvAnnouncementsRecordingTabComponent {
  @Input() announcement!: AdvAnnouncement;
  @Input() recording!: Recording | undefined;
  @Input() recordingArray!: Array<Recording | undefined>;
  @Input() lessThanMediumBreakpoint!: boolean;
  @Output() mode = new EventEmitter<"view" | "edit">();

  announcementShelfPanel = new BehaviorSubject<"view" | "edit">("view");

  togglePanel(panel: "view" | "edit"): void {
    this.announcementShelfPanel.next(panel);
    this.mode.emit(panel);
  }
}
